"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKConfigService = void 0;
var inversify_1 = require("inversify");
var SDKConfigService = /** @class */ (function () {
    function SDKConfigService() {
        this.config = {
            env: "test",
            autoTrack: false,
            enabled: false,
            prefix: "Aku",
            userId: "",
            appName: "Akulaku",
            countryId: "1",
            countryCode: "IN",
            filterEventObj: {
                enabled: false,
                eventArr: [],
            },
        };
    }
    SDKConfigService.prototype.get = function () {
        return this.config;
    };
    SDKConfigService.prototype.set = function (config) {
        var _this = this;
        var required = [
            "autoTrack",
            "enabled",
            "prefix",
            "userId",
            "appName",
            "countryId",
            "countryCode",
            "filterEventObj",
        ];
        Object.keys(config).forEach(function (k) {
            var key = k;
            var exist = _this.config[key];
            var newValue = config[key];
            var finalValue = required.includes(k) && typeof newValue === "undefined" ? exist : newValue;
            // @ts-expect-error 不知为何是 never type
            _this.config[key] = finalValue;
        });
    };
    SDKConfigService.prototype.update = function (config) {
        var _this = this;
        Object.keys(config).forEach(function (k) {
            var key = k;
            var exist = _this.config[key];
            var newValue = config[key];
            var finalValue = typeof newValue === "undefined" ? exist : newValue;
            // @ts-expect-error 不知为何是 never type
            _this.config[key] = finalValue;
        });
    };
    SDKConfigService = __decorate([
        (0, inversify_1.injectable)()
    ], SDKConfigService);
    return SDKConfigService;
}());
exports.SDKConfigService = SDKConfigService;
